import GoogleAnalyticsEvent from "../../../../../../../shared/src/ranj/analytics/GoogleAnalyticsEvent";
import GoogleAnalyticsStrings from "../../../../../../../shared/src/ranj/analytics/GoogleAnalyticsStrings";
import AbstractCommand from "../../../../../../../shared/src/ranj/app/core/AbstractCommand";
import NavigateEvent from "../../../../../../../shared/src/ranj/app/navigation/NavigateEvent";
import SkinFactory from "../../../../../../../shared/src/ranj/app/ui/SkinFactory";
import SkinKeys from "../../../../../../../shared/src/ranj/app/ui/SkinKeys";
import GameModel from "../../../model/GameModel";
import TrackingController from "../../../model/TrackingController";
import ScenarioPlayerEvent from "../../scenario/ScenarioPlayerEvent";
import DialogPlayerRegisterEvent from "./DialogPlayerRegisterEvent";


export default class PlayDialogCommand extends AbstractCommand {

    /**
     * 
     * @param {*} dispatcher 
     * @param {*} assetLibrary 
     * @param {*} variableManager 
     * @param {*} dialogFactory 
     * @param {*} dialogPlayer 
     * @param {GameModel} gameModel 
     * @param {TrackingController} trackingController 
     */
    constructor(dispatcher, assetLibrary, variableManager, dialogFactory, dialogPlayer, gameModel, trackingController) {
        super(dispatcher);
        this._assetLibrary = assetLibrary;
        this._variableManager = variableManager;
        this._dialogFactory = dialogFactory;

        this._dialogPlayer = dialogPlayer;
        this._gameModel = gameModel;
        this._trackingController = trackingController;

        this._handleContentCompletedBound = this._handleContentCompleted.bind(this);
    }

    execute(event) {
        const { content, contentPlayer, dialogMemento } = event.params.data;
        const dialogID = content.getDialogID();

        if (this._gameModel.skipToDialogId) {
            if (dialogID != this._gameModel.skipToDialogId) {
                contentPlayer.contentCompleted(content);
                return;
            } else {
                this._gameModel.skipToDialogId = null;//only once
            }
        }

        this.startDialog(content, contentPlayer, dialogMemento);

    }

    startDialog(content, contentPlayer, dialogMemento) {

        const dialogID = content.getDialogID();
        this._dialogID = dialogID;

        this._trackingController.trackDialogStart(dialogID);

        this._dialogPlayer.setContentPlayer(contentPlayer);
        this._dialogPlayer.setContent(content);

        this._gameModel.currentDialogPlayer = this._dialogPlayer;

        const dialog = this._dialogFactory.getDialog(dialogID);
        this._dialogPlayer.setDialog(dialog);

        if (dialogMemento) {
            this._dialogPlayer.loadMemento(dialogMemento);
        }

        var dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.REGISTER, this._dialogPlayer);
        this._dispatcher.dispatch(dprEvent.type, dprEvent);

        //GoogleAnalytics: set dialog id as value of custom dimension DIALOG so all events during dialog are attributed accordingly
        //	NB: unset again when dialog closes/completes
        this._dispatcher.dispatch(GoogleAnalyticsEvent.DIMENSION, { index: GoogleAnalyticsStrings.DIALOG, value: dialogID });

        this._dispatcher.addEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound, this);

        this._dialogPlayerSkin = SkinFactory.getSkin(SkinKeys.DIALOG_SCREEN_SKIN);
        this._dialogPlayerSkin.dialogPlayer = this._dialogPlayer;
        if (dialogMemento) {
            this._dialogPlayerSkin.dialogMemento = dialogMemento;
        }
        const commandEvent = new NavigateEvent(NavigateEvent.GOTO_SCREEN_REQUEST, this._dialogPlayerSkin.skinType, this._dialogPlayerSkin);
        this._dispatcher.dispatch(commandEvent.type, { data: commandEvent });

        this._startTime = Date.now();
        this._dialogPlayer.playContent();
    }

    _handleContentCompleted({ params }) {
        if (params.data.content === this._dialogPlayer.getContent()) {

            if (this._gameModel.currentDialogPlayer == this._dialogPlayer) {
                this._gameModel.currentDialogPlayer = null;
            }

            this._trackingController.trackDialogEnd(this._dialogID);
            // This dialog is complete: move on!
            this._dispatcher.removeEventListener(ScenarioPlayerEvent.CONTENT_COMPLETED, this._handleContentCompletedBound);

            var dprEvent = new DialogPlayerRegisterEvent(DialogPlayerRegisterEvent.DEREGISTER, this._dialogPlayer);
            this._dispatcher.dispatch(dprEvent.type, dprEvent);

            //var duration = Date.now()-this._startTime;
            //GoogleAnalytics: unset dialog id as value of custom dimension DIALOG 
            this._dispatcher.dispatch(GoogleAnalyticsEvent.DIMENSION, { index: GoogleAnalyticsStrings.DIALOG, value: null });

            // Close the content.
            const commandEvent = new NavigateEvent(NavigateEvent.CLOSE_SCREEN_REQUEST, null, this._dialogPlayerSkin);
            this._dispatcher.dispatch(commandEvent.type, { data: commandEvent });
            this.destroy();
        }
    }

    destroy() {
        this._dialogPlayer.destroy();
    }
}